<div class="note-history-container">
  @if (Versions.length <= 1) {
    <p class="no-history">No prior versions - this note has never been edited.</p>
  } @else {
    <div class="version-list">
      @for (version of Versions; track version.NoteVersionID) {
        <div class="version-card" [class.is-current]="version.IsCurrent">
          <div class="version-header">
            <strong>{{version.DateDisplay}} &middot; {{version.AuthorDisplay}}</strong>
            @if (version.IsCurrent) {
              <span class="current-badge">Current</span>
            }
          </div>
          <p class="version-text">{{version.NoteText}}</p>
          <div class="version-footer">
            C Market: {{version.CMarketValue != null ? (version.CMarketValue | number: '1.2-2') : '—'}}
          </div>
        </div>
      }
    </div>
  }
  <div class="button-container">
    <button mat-button class="btn-bg-blue" (click)="close()">Close</button>
  </div>
</div>
